import { AxiosRequestConfig } from "axios";
import { Pano, PanoScenario, WordpressPano, WordpressScenario } from "../../../types";
import { HardPanoViewLimits, transformWordpressPanos } from "../../../utils/panoUtils";
import { ICanRead } from "./ICanRead";
import { Repository } from "./Repository";

export class PanoRepository extends Repository implements ICanRead<Pano> {
  async get(restAuth: AxiosRequestConfig | undefined): Promise<Pano[]> {
    const data = await this.api.get(restAuth, "/wp/v2/pano");

    if (data) {
      const panos: Pano[] = data.map((item: any) => ({
        id: item.id,
        title: item.title.rendered,
      }));
      return panos;
    }

    return [];
  }

  async single(restAuth: AxiosRequestConfig | undefined, id: number): Promise<Pano> {
    const wp_data: WordpressPano = await this.api.single(restAuth, `/wp/v2/pano/${id}`);
    const acf = wp_data.acf;

    if (wp_data && acf) {
      const pano: Pano = {
        id: id,
        title: wp_data.title.rendered,
        content: wp_data.content.rendered,
        excerpt: wp_data.excerpt.rendered,
        view: {
          hlookat: +acf.yaw,
          vlookat: +acf.pitch,
          fov: +acf.fov,
          fovType: acf.fov_type,
        },
        limits: HardPanoViewLimits,
        slug: wp_data.slug,
        icon: acf.icon_type,
        type: acf.type,
        isIndoor: acf.indoor_outdoor === "indoor",
        showVideoControls: acf.video.show_controls,
        repeatVideo: acf.video.repeat,
        showInNavigation: acf.show_in_navigation,
        scenarios: await Promise.all(acf.scenarios.map(async (scenario) => {
          const wpScenario: WordpressScenario = await this.api.single(restAuth, `/wp/v2/scenario/${scenario.scenario}`);

          return {
            id: wpScenario.id,
            title: wpScenario.title.rendered,
            slug: wpScenario.slug,
            isVideo: scenario.resource.length > 1,
            showInNavigation: wpScenario.acf.show_in_menu,
          } as PanoScenario;
        })),
        featuredMedia: wp_data.featured_media,
        labels: acf.labels?.map((label, i) => ({
          id: `${i + 1}`,
          text: label.label_text,
          yaw: +label.yaw,
          pitch: +label.pitch,
        })) ?? [],
        status: wp_data.status,
        repeatAudio: acf.repeat_audio,
      };
      return pano;
    }

    return {} as Pano;
  }

  async update(item: Pano): Promise<Pano> {
    return item;
  }
}
